import { css } from '@emotion/core'
import { Link } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import Band from '../components/band'
import ImageViewer from '../components/image-viewer'
import img2 from '../images/predictive-poem/predictivepoem 10-01.jpg'
import img3 from '../images/predictive-poem/predictivepoem 11-01.jpg'
import img4 from '../images/predictive-poem/predictivepoem 22-01.jpg'
import img5 from '../images/predictive-poem/predictivepoem 24-01.jpg'
import img6 from '../images/predictive-poem/predictivepoem 25-01.jpg'
import img7 from '../images/predictive-poem/predictivepoem 27-01.jpg'
import img8 from '../images/predictive-poem/predictivepoem 30-01.jpg'
import img9 from '../images/predictive-poem/predictivepoem 36-01.jpg'
import img10 from '../images/predictive-poem/predictivepoem 41-01.jpg'
import img11 from '../images/predictive-poem/predictivepoem 43-01.jpg'
import img12 from '../images/predictive-poem/predictivepoem 45-01.jpg'
import img1 from '../images/predictive-poem/predictivepoem 8-01.jpg'

const PredictivePoem = () => (
  <section>
    <Helmet>
      <meta
        property="og:url"
        content="http://futurologi.org/ai-monologer/predictive-poem/  "
      />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Predictive Poem" />
      <meta
        property="og:description"
        content="Human knowledge and military operations are great as long as knowledge and products that use algorithms and knowledge of their products is critical to the technology and knowledge."
      />
      <meta
        property="og:image"
        content="http://futurologi.org/ai-monologer/predictive-poem.jpg"
      />
      <meta property="og:image:type" content="image/jpeg" />
    </Helmet>
    <Band
      left={
        <Link
          css={css`
            font-size: 1.5rem;
            font-weight: 900;
            text-decoration: none;
          `}
          to="/"
        >
          <span
            css={css`
              color: orchid;
            `}
          >
            ⥺
          </span>
        </Link>
      }
    >
      Predictive Poem // Johanne Østervang
    </Band>

    <ImageViewer
      images={[
        img1,
        img2,
        img3,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9,
        img10,
        img11,
        img12,
      ]}
    />
  </section>
)

export default PredictivePoem
